export enum GratitudeQuestion {
  bestPartOfTheDay = "bestPartOfTheDay",
  gratefulFor = "gratefulFor",
  peopleThatMakeYouHappier = "peopleThatMakeYouHappier",
  whatILearned = "whatILearned",
}
